import React, { useState, useEffect } from "react";
import userIcon from "../../assets/user.png";

import "../../styles/Sidebar.css";

const Sidebar = ({
    menuItems,
    selectedMenu,
    drawerOpen,
    toggleDrawer,
    onLogout,
    onMenuSelect,
    setDrawerOpen,
    userData,
    cartItems,
    onCheckoutClick,

}) => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const user = userData || JSON.parse(localStorage.getItem("user")) || {};

    const UserInfo = () => {
        if (!user?.name) {
            return null; // 🔥 Jangan render jika user belum wujud
        }

        return (
            <div className="user-info">
                <div className="user-avatar">
                    <img src={userIcon} alt="User Avatar" className="avatar-icon" />
                    <p className="user-name">{user?.name || "Pengguna"}</p> {/* ✅ Elak error */}
                </div>
                {user?.role !== "pengarah" && (
                    <>
                        <p className="user-location">
                            {user?.role === "pengerusi" ? user?.district || "-" : user?.branchName || "-"}
                        </p>
                        <p className="user-location">
                            {user?.role === "pengurus" ? user?.district : null}
                        </p>
                    </>
                )}

            </div>
        );
    };


    return (
        <>
            {/* Mobile Sidebar (Drawer) */}
            {isMobile && drawerOpen && (
                <div
                    className="sidebar-drawer open"
                    onClick={(e) => {
                        if (drawerOpen) {
                            toggleDrawer();
                        }
                    }}
                >
                    <div
                        className="sidebar-content"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="upper-content">
                            <ul className="sidebar-list">
                                {menuItems.map((item) => (
                                    <li
                                        key={item}
                                        className={`sidebar-item ${selectedMenu === item ? "active" : ""}`}
                                        onClick={() => {
                                            onMenuSelect(item);
                                            setTimeout(() => {
                                                if (isMobile && drawerOpen) {
                                                    setDrawerOpen(false);
                                                }
                                            }, 50);
                                        }}
                                    >
                                        {item}
                                    </li>
                                ))}
                                {/* ✅ Paparkan "Sahkan Tempahan" hanya jika user ialah "pengurus" */}
                                {user?.role === "pengurus" && (
                                    <li
                                        className="sidebar-item checkout-item"
                                        onClick={onCheckoutClick}
                                    >
                                        Troli
                                        {cartItems.length > 0 && (
                                            <span className="cart-badge">{cartItems.length}</span>
                                        )}
                                    </li>
                                )}
                            </ul>
                        </div>

                        <div className="bottom-content">
                            <UserInfo />
                            <p
                                className="logout-button"
                                onClick={() => {
                                    onLogout();
                                    if (isMobile) toggleDrawer();
                                }}
                            >
                                Keluar
                            </p>
                        </div>
                    </div>
                </div>
            )}

            {/* Desktop Sidebar (Always Visible) */}
            {!isMobile && (
                <div className="sidebar-container">
                    <div className="upper-content">
                        <ul className="sidebar-list">
                            {menuItems.map((item) => (
                                <li
                                    key={item}
                                    className={`sidebar-item ${selectedMenu === item ? "active" : ""}`}
                                    onClick={() => onMenuSelect(item)}
                                >
                                    {item}
                                </li>
                            ))}
                            {/* ✅ Paparkan "Sahkan Tempahan" hanya jika user ialah "pengurus" */}
                            {user?.role === "pengurus" && (
                                <li
                                    className="sidebar-item checkout-item"
                                    onClick={onCheckoutClick}
                                >
                                    Troli
                                    {cartItems.length > 0 && (
                                        <span className="cart-badge">{cartItems.length}</span>
                                    )}
                                </li>
                            )}
                        </ul>
                    </div>

                    <div className="bottom-content">
                        <UserInfo />
                        <p className="logout-button" onClick={onLogout}>Keluar</p>
                    </div>
                </div>
            )}
        </>
    );
};

export default Sidebar;
